<template>

  <div>
    <b-overlay :show="overlay">
      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <div class="flags-filter-wrapper mr-1">
                  <feather-icon
                      icon="FilterIcon"
                      size="16"
                      class="flags-filter-icon text-muted"
                  />
                  <v-select
                      v-model="flagsFilter"
                      :options="flagOptions"
                      :reduce="opt => opt.value"
                      label="label"
                      multiple
                      :close-on-select="false"
                      class="flags-filter-selector"
                      placeholder="Filtrar por flag"
                  />
                </div>
                <b-input-group class="mr-1">
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por código, descrição ou referência..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
  <!--              <b-button-->
  <!--                  variant="primary"-->
  <!--                  v-b-modal.modal-add-item-->
  <!--                  @click="resetFormData"-->
  <!--              >-->
  <!--                <div class="d-flex" style="gap: 5px">-->
  <!--                  <iconfy icon="mdi:plus"/>-->
  <!--                  <span class="">Item</span>-->
  <!--                </div>-->
  <!--              </b-button>-->
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refItemListTable"
            class="position-relative"
            :items="fetchItem"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(item_situacao)="data">
            <b-badge
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                :variant="resolveItemStatusVariant(data.item.item_situacao)"
                class="text-primary"
            >
              {{ data.item.item_situacao }}
            </b-badge>
          </template>

          <!-- Bolinhas verde/vermelha por tipo (paridade com o sistema antigo) -->
          <template #cell(flagvendavel)="data">
            <span class="flag-dot" :class="Number(data.item.flagvendavel) === 1 ? 'flag-dot--on' : 'flag-dot--off'" :title="Number(data.item.flagvendavel) === 1 ? 'Vendável' : 'Não vendável'" />
          </template>
          <template #cell(flagdoavel)="data">
            <span class="flag-dot" :class="Number(data.item.flagdoavel) === 1 ? 'flag-dot--on' : 'flag-dot--off'" :title="Number(data.item.flagdoavel) === 1 ? 'Doável' : 'Não doável'" />
          </template>
          <template #cell(flagcertificacao)="data">
            <span class="flag-dot" :class="Number(data.item.flagcertificacao) === 1 ? 'flag-dot--on' : 'flag-dot--off'" :title="Number(data.item.flagcertificacao) === 1 ? 'Certificação' : 'Sem certificação'" />
          </template>

          <template #cell(estoque_info)="data">
            <estoque-badge :estoque-info="estoqueMapRef[data.item.item_id]" />
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="d-flex">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-primary"
                  title="Visualizar"
                  class="btn-icon mr-1"
                  @click="$router.push({ name: 'apps-item-edit', params: { id: data.item.item_id, pageTitle: 'Editar Item' } })"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>

              <!-- Vincular clientes: só para produtos customizados (exclusivos) -->
              <b-button
                  v-if="isCustomizado(data.item)"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-warning"
                  title="Vincular clientes (produto exclusivo)"
                  class="btn-icon"
                  @click="abrirModalVincular(data.item)"
              >
                <feather-icon icon="LinkIcon"/>
              </b-button>
            </div>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{
                  dataMeta.of
                }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItem"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <ModalAdd
        idModal="modal-add-item"
        titleModal="Visualizar item"
        :labelBtnOk="dataItem.item_id !== null ? 'Atualizar' : 'Adicionar'"
        v-model="dataItem"
        @ok="createOrUpdated($event)"
        @cancel="resetFormData()"
    />

    <ModalVincularClientes
        id-modal="modal-vincular-clientes"
        :item="itemVincular"
    />

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-item"
        title="Deletar Item"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim, deletar"
        @ok="handleRemover(deletedCustomField.item_id)"
        @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa Item?</p>
        </div>
      </template>
    </modal-confirmation>

  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import SLSitemExService from '@/services/SistemaDKP/SLSitemEx.service';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import EstoqueBadge from '@/components/EstoqueBadge.vue';
import ModalAdd from './ModalAdd.vue';
import ModalVincularClientes from './ModalVincularClientes.vue';
import useList from './useList';

const estoqueService = new SLSEstoqueService();

export default {
  components: {
    ModalAdd,
    ModalVincularClientes,
    EstoqueBadge,
    BAvatar,
    BLink,
    BMedia,
    ModalConfirmation,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedCustomField: {
        item_id: null,
        item_descricao: '',
        item_peso_bruto: '',
        item_peso_liquido: '',
        item_codigo_origem: '',
      },
      searchInputValue: '',
      estoqueMap: {},
      itemVincular: null,
    };
  },
  methods: {
    applyGlobalSearchQuery() {
      const q = this.$route?.query?.q;
      if (!q) return;
      const value = Array.isArray(q) ? q[0] : q;
      this.searchInputValue = value;
      this.searchQuery = value;
    },
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Item deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataItem = data;
      this.$bvModal.show('modal-add-item');
    },
    resetFormData() {
      this.deletedCustomField = {
        item_id: null,
        item_descricao: '',
        item_peso_bruto: '',
        item_peso_liquido: '',
        item_codigo_origem: '',
      };
      this.dataItem = {
        item_id: null,
        item_descricao: '',
        item_peso_bruto: '',
        item_peso_liquido: '',
        item_codigo_origem: '',
      };
      this.isDeleteModal = false;
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
    isCustomizado(item) {
      // flagcustomizado pode chegar como 1, '1', true — normaliza.
      const v = item && item.flagcustomizado;
      return v === 1 || v === '1' || v === true;
    },
    abrirModalVincular(item) {
      this.itemVincular = item;
      this.$bvModal.show('modal-vincular-clientes');
    },
  },
  setup() {
    const sLSitemExService = new SLSitemExService();
    const customFields = ref([]);
    const dataItem = ref({
      item_id: '',
      item_descricao: '',
      item_peso_bruto: '',
      item_peso_liquido: '',
      item_codigo_origem: '',
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);
    const refCollapeseCamposPadrao = ref(null);
    const refCollapeseCamposPersonalizados = ref(null);

    const listarCustomFields = async () => {
      customFields.value = await sLSitemExService.index();
    };

    onMounted(async () => {
      await listarCustomFields();
    });
    const toggleCollapseALl = () => {
      spanderAll.value = !spanderAll.value;
      console.log(refCollapeseCamposPadrao.value);
    };
    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const estoqueMapRef = ref({});

    const {
      perPage,
      currentPage,
      totalItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refItemListTable,
      fetchItem,
      overlay,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      createOrUpdated,
      removerData,
      flagsFilter,
      flagOptions,
    } = useList(undefined, (map) => {
      estoqueMapRef.value = { ...estoqueMapRef.value, ...map };
    });

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,

      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      refCollapeseCamposPadrao,
      refCollapeseCamposPersonalizados,
      toggleCollapseALl,
      currentTab,
      dataItem,
      typeOptionsCustomFields,
      listarCustomFields,
      customFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,

      perPage,
      currentPage,
      totalItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchItem,
      overlay,
      tableColumns,
      refItemListTable,
      createOrUpdated,
      removerData,
      estoqueMapRef,
      flagsFilter,
      flagOptions,
    };
  },
  created() {
    this.applyGlobalSearchQuery();
  },
  watch: {
    '$route.query.q': function () {
      this.applyGlobalSearchQuery();
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}

.flags-filter-wrapper {
  position: relative;
  display: flex;
  align-items: center;

  .flags-filter-icon {
    position: absolute;
    left: 10px;
    z-index: 3;
    pointer-events: none;
  }

  .flags-filter-selector {
    min-width: 220px;

    ::v-deep .vs__dropdown-toggle {
      padding-left: 26px;
    }
  }
}

.flag-dot {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;

  &--on {
    background-color: #28c76f;
  }

  &--off {
    background-color: #ea5455;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
